import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import FlexColumn from '../shared/components/layouts/FlexColumn'
import LoginCredentialsForm from './login/LoginCredentialsForm'
import LoginOtpForm from './login/LoginOtpForm'
import LoginLocationConfirmation from './login/LoginLocationConfirmation'

const LOGIN_STEPS = {
  CREDENTIALS: 'credentials',
  TWO_FACTOR: 'twoFactor',
  LOCATION_CONFIRMATION: 'locationConfirmation',
}

const Login = () => {
  const navigate = useNavigate()
  const [step, setStep] = useState(LOGIN_STEPS.CREDENTIALS)
  const [loginToken, setLoginToken] = useState(null)
  const [confirmationToken, setConfirmationToken] = useState(null)
  const [serverMessage, setServerMessage] = useState(null)

  const handleResult = useCallback((result) => {
    switch (result.type) {
      case 'token':
        navigate('/')
        break
      case 'twoFactorRequired':
        setLoginToken(result.loginToken)
        setServerMessage(result.message)
        setStep(LOGIN_STEPS.TWO_FACTOR)
        break
      case 'locationConfirmationRequired':
        setConfirmationToken(result.confirmationToken)
        setServerMessage(result.message)
        setStep(LOGIN_STEPS.LOCATION_CONFIRMATION)
        break
    }
  }, [navigate])

  return (
    <Container maxWidth="sm">
      <FlexColumn gap={2} sx={{ mt: 8 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          <FormattedMessage id="login.title" />
        </Typography>

        {step === LOGIN_STEPS.CREDENTIALS && (
          <LoginCredentialsForm onResult={handleResult} />
        )}

        {step === LOGIN_STEPS.TWO_FACTOR && (
          <LoginOtpForm
            loginToken={loginToken}
            message={serverMessage}
            onResult={handleResult}
          />
        )}

        {step === LOGIN_STEPS.LOCATION_CONFIRMATION && (
          <LoginLocationConfirmation
            confirmationToken={confirmationToken}
            message={serverMessage}
            onResult={handleResult}
          />
        )}
      </FlexColumn>
    </Container>
  )
}

export default Login
